// Inventory Products Vuex

import state from './productStates.js'
import * as getters from './productGetters.js'
import * as mutations from './productMutations.js'
import * as actions from './productActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
